import { AccessControlListApi } from '@agilelab/plugin-wb-access-control-common';
import { AccessRequestHookUpdateAction } from '@agilelab/plugin-wb-action-handler-common';

export const MARKETPLACE_PENDING_REQUEST_PANEL_OPEN_QUERY_PARAM =
  'pending-requests' as const;

export const MARKETPLACE_ACCESS_CONTROL_SUB_ROUTE: string = '/control-center';

export interface BulkApproveResult {
  hookId: string;
  success: boolean;
  error?: string;
}

/**
 * Approves or rejects multiple access request hooks with bounded concurrency.
 * Processes requests in batches to avoid overwhelming the server.
 */
export async function bulkUpdateAccessRequestHooks(
  hookIds: string[],
  action: AccessRequestHookUpdateAction,
  api: AccessControlListApi,
  concurrencyLimit = 5,
): Promise<BulkApproveResult[]> {
  const results: BulkApproveResult[] = [];

  for (let i = 0; i < hookIds.length; i += concurrencyLimit) {
    const batch = hookIds.slice(i, i + concurrencyLimit);
    const batchResults = await Promise.allSettled(
      batch.map(hookId => api.updatePendingAccessRequestHook(hookId, action)),
    );
    batchResults.forEach((result, idx) => {
      results.push({
        hookId: batch[idx],
        success: result.status === 'fulfilled',
        error:
          result.status === 'rejected' ? result.reason?.message : undefined,
      });
    });
  }

  return results;
}
